import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";
import date from "utils/date";

export default ({ companyId, smsReloads, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (smsReloads.loading) {
      return "is Loading";
    }
    if (isEmpty(smsReloads.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }

    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>Date</th>
            <th>User</th>
            <th>Amount</th>
            <th>Note</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {smsReloads.data.map(({ id, user, amount, note, created_at }) => (
            <tr key={id}>
              <td>
                <a>{created_at}</a>
              </td>
              <td>{user.name}</td>
              <td>{amount}</td>
              <td>{note}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/companies/${companyId}/sms-reloads/${id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(id)}
                    to={`/companies/${companyId}/sms-reloads/${id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Company/SmsReload/Table.js